import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import {RootState} from "../services/rootReducer";

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { getCurrentFacets, getAvailableFacets, setCurrentFacetsMap, FacetsMap, FacetsMapPayload, setFacetsMap } from 'services/Facets_Slice';
import { cursorsType, setCursors, getInitialColorMaps, getGradientMap, selectPageRange, selectDateInterval } from "../services/View_Slice"
import { applyFacetWithNavigation, removeFacetWithRestore } from "../services/FacetNavigation_Slice"

import { Button } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css';
import { Container } from "react-bootstrap";
import HighlightOff from "@material-ui/icons/HighlightOff";
import styles from "./css/Facets.module.css";

import CollapsableDiv from "./CollapsableDiv";
import AdditionalSources from "./AdditionalSources";

import CONSTANTS from "../constants";
//
import logger from "../logger"


interface Dictionary<T> {
    [Key: string]: T;
}

const NO_FACET_VALUES_TO_DISPLAY = "Not Available";
const initialState: any = undefined;

//type propsType = {
//    constraint: Array<string>
//}

function Facets(){ //props: React.PropsWithChildren<propsType>) {
    //
    const [precedentFacetSelected, setPrecedentFacetSelected] = useState(initialState);

    //const facetConstraints = props.constraint;

    //var precedentFacetSelected: any = undefined;
    const {currentFacetMap, facetSelected, facetMap} = useSelector(
        (state: RootState) => ({
            currentFacetMap: state.Facets.currentFacetMap,
            facetSelected: state.Facets.facetSelected,
            facetMap: state.Facets.facetMap,
        }),
        shallowEqual
    );
    const pageRangeUsed = useSelector(selectPageRange);
    const pageRangeRef = useRef(pageRangeUsed);
    pageRangeRef.current = pageRangeUsed;

    const { dateIntervalFrom, dateIntervalTo } = useSelector(selectDateInterval);
    const mobile = useSelector((state: RootState) => state.View.mobile);
    const urlFacetsConstraints = useSelector((state: RootState) => state.View.urlFacetsConstraints);
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch);

    const dispatch = useDispatch();

    const handleFacetSelected = useCallback((value: string) => {
        dispatch(applyFacetWithNavigation(value));
        dispatch(setCursors({ cursorStart: 0, cursorRows: pageRangeRef.current }));
    }, [dispatch]);

    const handleFacetRemoved = useCallback((facetKey: string) => {
        dispatch(removeFacetWithRestore(facetKey));
        dispatch(setCursors({ cursorStart: 0, cursorRows: pageRangeRef.current }));
    }, [dispatch]);


    // const operator = 'Or'; /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */
    //logger.info("@@@ Facets currentFacetMap:"+ JSON.stringify(currentFacetMap));
    //logger.info("@@@ Facets facetSelected:"+ JSON.stringify(facetSelected));
    ////logger.info("@@@ Facets facetConstraints:"+ JSON.stringify(facetConstraints));
    //logger.info("@@@ Facets facetConstraints from store:urlConstraints:"+ JSON.stringify(urlFacetsConstraints));

    // use effect to load facets from server
    useEffect(() => {
        dispatch(getAvailableFacets(urlFacetsConstraints))
        //logger.info("$$$$ getting available")
      }, [dispatch, urlFacetsConstraints]);

    useEffect(() => {
        dispatch(getInitialColorMaps())
      }, [dispatch]);

    /*
    Refreshes currentFacets when facetSelected, facetMap, search, or date range changes.
    This is now the SINGLE place that calls getCurrentFacets (removed duplicate calls from click handlers).
    */
    useEffect(() => {

        if (facetMap && Object.keys(facetMap).length > 0) {
            dispatch(getCurrentFacets(facetMap, facetSelected, CONSTANTS.DEFAULT_OPERATOR_TO_USE, freeTextSearch, dateIntervalFrom, dateIntervalTo)); /* === AND/OR OPERATOR FEATURE - USING DEFAULT CONSTANT === */
        }
    }, [dispatch, facetMap, facetSelected, freeTextSearch, dateIntervalFrom, dateIntervalTo]);

    /* when a facet is selected, this will cause a unnecessary call to /real/getGradientMap
       RISOLVED: use a local state with facetSelected, and requery getGradientMap only when there is change
    */
    useEffect(() => {
        //logger.info(" ## Facets useEffect: precedentFacetSelected:" + JSON.stringify(precedentFacetSelected));
        //logger.info(" ## Facets useEffect: facetSelected:" + JSON.stringify(facetSelected));
        if(precedentFacetSelected===facetSelected){
            //logger.info(" ## Facets useEffect: == do nothing");
        }else{
            //logger.info(" ## Facets useEffect: !== do query");
            setPrecedentFacetSelected(facetSelected);
            //qui c'era il getGradientMap
        }
      }, [dispatch, precedentFacetSelected, setPrecedentFacetSelected]);
    

    const compToRender = useMemo(() => currentFacetMap!==undefined ? Object.keys(currentFacetMap).map((item, index) => {

        // facets names
        var values:Array<string> = [];
        //var n=0;
        for (var val in currentFacetMap[item]){
            if(currentFacetMap[item][val] === ""){
                //console.log("currentFacetMap[item][val] === ''");
                continue;
            }
            //logger.debug("## Facets; facet in facet '" +item + "': val["+val+"]:"+ currentFacetMap[item][val]);
            values.push(currentFacetMap[item][val]);
            //n+=1;
        }

        // facet values selected
        var disabled: Array<string> = [];
        if (facetSelected!==undefined){
            for(var val1 in facetSelected){
                //logger.info("## Facets; test facetSelected in facet '" + item + "': val1="+ facetSelected[val1]);
                if(facetSelected[val1].split("@")[1] === item){
                    disabled.push(facetSelected[val1].split("@")[0]);
                    //logger.info("## Facets; disabled in facet '" + item + "': " + facetSelected[val1].split("@")[0]);
                }else{
                    //logger.info("## Facets; not disabled in facet '" + item + "': " + facetSelected[val1].split("@")[1] + "' VS '" + item + "'");
                }

            }
        }else{
            //logger.info("## Facets; facetSelected==undefined");
        }
        //logger.info("## Facets ##########; disabled:"+disabled);

        const disableToRender = disabled.map(value => {
            return(
                <div key={value} className={styles.filterChip}>
                    <Button appearance="link"
                        onClick = {() => handleFacetRemoved(value+"@"+item)}
                        value={value}
                        className={styles.glButtonn}>
                        <HighlightOff className={styles.glIcon}/>
                    </Button>
                    {value}
                </div>
            )
        });


        // remove disabled from values if present
        // URL constraint: if any value is passed, disable the facet values in all cases
        var valuesBis = [...values].filter(item2 => ! disabled.includes(item2));
        //logger.info("## Facets ########## facet name: " + item + " final0 values to render="+ valuesBis);
        if(disableToRender.length>0){
            valuesBis=[];
            //logger.info("## Facets ########## facet name: " + item + " final1 values to render="+ valuesBis);
        }else{
            //logger.info("## Facets ########## facet name: " + item + " final2 values to render="+ valuesBis);
        }

        // the facet label we want
        const itemLabel: string = item in CONSTANTS.UI.FACETS_ALIAS ? CONSTANTS.UI.FACETS_ALIAS[item] : item;
        //logger.info("## Facets itemLabel: " + itemLabel);

        var valuesToShow:Array<string> = [];
        if(valuesBis.length === 0){
            valuesToShow.push(NO_FACET_VALUES_TO_DISPLAY);
        }
        valuesBis.sort();

        

        return (
            <div key={item}>
                <div className={styles.space}></div>
                {disableToRender.length > 0 ? <span className={styles.glActiveFilterLabel}>Active filter:</span> : <span></span> }
                <div className={styles.activeFiltersContainer}>
                    {disableToRender}
                </div>



                { valuesBis.length > 0 ?
                    <CollapsableDiv key={item} label={itemLabel} name={item} values={valuesBis} notAvailable={false} open={(index === 0 || index === Object.keys(currentFacetMap).length - 1)} onFacetSelected={handleFacetSelected}>
                    {item}
                    </CollapsableDiv>:

                
                    <CollapsableDiv key={item} label={itemLabel} name={item} values={valuesToShow} notAvailable={true} open={(index === 0 || index === Object.keys(currentFacetMap).length - 1)}>
                    </CollapsableDiv>}


            </div>
        )
    }) : <div>{CONSTANTS.STATE_NOT_SET}</div>, [currentFacetMap, facetSelected, handleFacetSelected, handleFacetRemoved]);


    const usedStyle = mobile ? styles.container_mobile: styles.container;
    
    return (
        <Container className={usedStyle}>
            {compToRender}
            <AdditionalSources />
        </Container>
    );
}

export default React.memo(Facets);
